<template>
  <h1>{{ previewData.meta.title }}</h1>
  <h3 class="text-body-secondary">{{ previewData.subtitle }}</h3>
  <sup v-if="previewData.last_published_at" class="fst-italic">
    <span v-if="areDatesDifferent(previewData)">
      {{ translate('Last updated') }}: {{ getPublicationDate(previewData) }}<br />
    </span>
    {{ translate('Created') }}: {{ getCreationDate(previewData) }}
  </sup>
  <div v-if="previewData.introduction">
    <hr />
    <p class="fs-5">{{ previewData.introduction }}</p>
  </div>
  <hr />
  <img
    v-if="previewData.image"
    :src="previewData.image.url"
    :alt="previewData.meta.title"
    class="mb-3 mx-auto d-block"
  />
  <div id="content" class="w-100">
    <BlockController :content="previewData.content" />
  </div>
  <div v-if="previewData.tags?.length">
    <hr />
    <ul class="list-group list-group-horizontal">
      <li v-for="tag in previewData.tags" :key="tag" class="list-group-item m-0 p-1">
        <span class="badge text-bg-secondary">{{ tag }} </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
interface Props {
  previewData: any;
}

defineProps<Props>();

const {displayTimeStamp, translate} = useLocalisation();

const getPublicationDate = (newsItem: NewsItem) => {
  const date = new Date(Date.parse(newsItem.meta.last_published_at));
  return displayTimeStamp(date);
};

const getCreationDate = (newsItem: NewsItem) => {
  const date = new Date(Date.parse(newsItem.meta.first_published_at));
  return displayTimeStamp(date);
};

const areDatesDifferent = (newsItem: NewsItem) => {
  return getPublicationDate(newsItem) !== getCreationDate(newsItem);
};
</script>

<style scoped lang="scss">
:deep(.richtext-image) {
  padding: 0.5rem 0;
}

:deep(.richtext-image.full-width) {
  width: 100%;
}

:deep(.richtext-image.left) {
  float: left;
}

:deep(.richtext-image.right) {
  float: right;
}
</style>
